import { Component, signal } from "@angular/core";
import {
  ActivatedRoute,
  NavigationEnd,
  PRIMARY_OUTLET,
  Router,
  RouterModule,
} from "@angular/router";
import { filter, map } from "rxjs";
import { FeatherIconsComponent } from "../feather-icons/feather-icons.component";
import { TranslateService } from "@ngx-translate/core";
import { HOME_ROUTE } from "../../constants/constants";
import { Location } from "@angular/common";
import { LayoutService } from "../../services/layout.service";

@Component({
  selector: "app-breadcrumb",
  imports: [RouterModule, FeatherIconsComponent],
  templateUrl: "./breadcrumb.component.html",
  styleUrls: ["./breadcrumb.component.scss"],
})
export class BreadcrumbComponent {
  public breadcrumbs: {
    parentBreadcrumb?: string;
    childBreadcrumb?: string;
    enable?: boolean;
  };
  public title: string = "";
  HOME_ROUTE: any | string = HOME_ROUTE;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
    private location: Location,
    public layoutService: LayoutService
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .pipe(filter((route) => route.outlet === PRIMARY_OUTLET))
      .subscribe((route) => {
        let snapshot = this.router.routerState.snapshot;
        let title = this.translateService.instant(route.snapshot.data["title"]);

        let parent = null;
        let searchRoute = route.parent;

        while (searchRoute) {
          const routeConfig = searchRoute.routeConfig;
          const breadcrumb = searchRoute.snapshot.data?.["breadcrumb"];
          const routeTitle = searchRoute.snapshot.data?.["title"];

          if (routeConfig?.loadChildren) {
            parent = breadcrumb || routeTitle;
            break;
          }

          searchRoute = searchRoute.parent;
        }

        if (parent) {
          parent = this.translateService.instant(parent);
        }

        let isEnable = route.parent?.snapshot.data["isEnable"];

        const childBreadcrumb =
          route.snapshot.data["breadcrumb"] || route.snapshot.data["title"];
        let child = this.translateService.instant(childBreadcrumb);

        this.breadcrumbs = {};
        this.title = title;
        this.breadcrumbs = {
          parentBreadcrumb: parent,
          childBreadcrumb: child,
          enable: isEnable,
        };
      });
  }

  goBack() {
    this.location.back();
  }
}
